module.exports = __webpack_public_path__ + "img/img-5.33cf6a2a.jpg";